const rollen = [
    { value: 'ADMINISTRATOR', text: 'Administrator' },
    { value: 'PROJEKTBERATER', text: 'Projektberater' },
]

export default rollen;